import React, { useMemo, useCallback } from "react";
import cn from "classnames";

import styles from "./style.module.scss";
import { getCountryName, useI18n, LocalisedText } from "../../i18n";

interface AddressOptionItemProps {
  isSelected: boolean;
  index: number;
  country: string;
  address1: string;
  address2: string;
  onSelect: (index: number) => void;
  onRemove: (index: number) => void;
  isDisabled?: boolean;
}

const AddressOptionItem: React.FC<AddressOptionItemProps> = (
  props: AddressOptionItemProps
) => {
  const {
    address1,
    address2,
    country,
    isSelected,
    onSelect,
    onRemove,
    index,
    isDisabled,
  } = props;
  const i18n = useI18n();
  const locale = useMemo(() => {
    return i18n.locale.toString();
  }, [i18n]);

  const handleOnSelected = useCallback(() => {
    if (isDisabled) return;
    onSelect(index);
  }, [onSelect, index, isDisabled]);

  const handleOnRemove = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      e.preventDefault();
      e.stopPropagation();
      if (isDisabled) return;
      onRemove(index);
    },
    [onRemove, index, isDisabled]
  );

  return (
    <div className={styles.option} onClick={handleOnSelected}>
      <div
        className={cn(styles.selectionBox, {
          [styles.selected]: isSelected,
        })}
      >
        <div className={styles.selectedDot} />
      </div>
      <div className={styles.addressField}>
        {`${address1} ${address2} ${getCountryName(country, locale)}`}
      </div>
      <button className={styles.removeButton} onClick={handleOnRemove}>
        <LocalisedText id="view.addressOptionItem.remove" />
      </button>
    </div>
  );
};

export default AddressOptionItem;
